<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#service-list-container {
        position: absolute;
        top: 75px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        background-color: white;
        overflow-y: scroll;

        div.services-grid-container {
            max-width: 1200px;
            margin: auto;
            margin-top: 35px;

            div.no-results {
                margin-top: 20px;
                text-align: center;

                span {
                    font-size: 20px;
                }
            }
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        div.services-grid-container {
            height: inherit;
        }
    }
</style>

<template>
    <div id="service-list-container">
        <!--
        <div class="grid-x grid-padding-x services-grid-container">
            <list-filters></list-filters>
        </div>
        -->

        <div class="grid-x grid-padding-x services-grid-container" id="service-grid">
            <service-card v-for="service in services" :key="service.id" :service="service"></service-card>

            <div class="large-12 medium-12 small-12 cell no-results">
                <!--
                <span v-if="services.length == 0">Žádný servis nebyl nalezen, zadejte prosím adresu nebo povolte polohové služby.</span>
                -->
            </div>
        </div>
    </div>
</template>

<script>
    import ServiceCard from '../../components/services/ServiceCard.vue';

    export default {
        components: {
            ServiceCard
        },

        data() {
            return {

            }
        },

        computed: {
            services() {
                return this.$store.getters.getServices;
            },

            servicesView() {
                return this.$store.getters.getServicesView;
            }
        }
    }
</script>
